import React from "react";
import { useIntl } from "react-intl";

import { ColumnProps } from "src/common/components/DataTable";
import { messages } from "src/views/invitation-list/messages";

export function useInvitationListColumns(): ColumnProps[] {
	const { formatMessage } = useIntl();
	return React.useMemo(
		() => [
			{ key: "name", label: formatMessage(messages.name) },
			{ key: "email", label: formatMessage(messages.email) },
			{ key: "role", label: formatMessage(messages.role) },
			{ key: "generated", label: formatMessage(messages.generated) },
			{ key: "expires", label: formatMessage(messages.expires) }
		],
		[formatMessage]
	);
}
